export function valueOf({initial, spent, added}: Budget): MoneyAmount {
  return Math.max(initial - spent + added, 0);
}
